module.exports = __webpack_public_path__ + "img/Large-Vertical-Rectangular-Attachment-34.c27122c4.png";